module.exports = __webpack_public_path__ + "static/POTY_Delivery_2023-52839daea089f853bb49cf2c971b8790.svg";